function intToRating(value) {
  return (5 * (value / 10000)).toLocaleString("pt-br", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });
}

function ratingToInt(rating) {
  return parseInt(((rating * 100) / 5) * 100);
}

export default {
  intToRating,
  ratingToInt
};



// WEBPACK FOOTER //
// ./src/utils/formatters/rating.js